import './FileSizeErrorModal.css';

import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'reactstrap';

class FileSizeErrorModal extends React.Component {
  render() {
    const { onClose, fileName, fileSize, maxSize, minSize } = this.props;

    const formatFileSize = (sizeInBytes) => {
      if (sizeInBytes < 1024) {
        return `${sizeInBytes} bytes`;
      }
      if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(1)} KB`;
      }
      return `${(sizeInBytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    const getErrorMessage = () => {
      if (minSize && fileSize < minSize) {
        return `The file "${fileName}" is too small. Minimum file size is ${formatFileSize(minSize)}.`;
      }
      if (maxSize && fileSize > maxSize) {
        return `The file "${fileName}" is too large. Maximum file size is ${formatFileSize(maxSize)}.`;
      }
      return 'The file size is not within the allowed limits.';
    };

    return (
      <div className="file-size-error-modal">
        <div className="card-block">
          <div className="error-icon">
            <i className="fa fa-exclamation-triangle" />
          </div>
          <div className="error-title">File Size Error</div>
          <div className="error-message">{getErrorMessage()}</div>
          <div className="file-details">
            <div>
              File: <strong>{fileName}</strong>
            </div>
            <div>
              Size: <strong>{formatFileSize(fileSize)}</strong>
            </div>
            {maxSize && (
              <div>
                Maximum allowed: <strong>{formatFileSize(maxSize)}</strong>
              </div>
            )}
            {minSize && (
              <div>
                Minimum required: <strong>{formatFileSize(minSize)}</strong>
              </div>
            )}
          </div>
          <div className="bottom-buttons">
            <Button className="btn btn-primary" onClick={onClose}>
              OK
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

FileSizeErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  fileName: PropTypes.string.isRequired,
  fileSize: PropTypes.number.isRequired,
  maxSize: PropTypes.number,
  minSize: PropTypes.number,
};

export default FileSizeErrorModal;
